<template>
  <sheet-modal :model-value="modelValue" :title="title" exact-width="w-[520px]" body-class="px-8 pt-4 pb-6" scrollable
               data-testid="keyboard-shortcuts-modal" @update:model-value="emit('update:modelValue', $event)">
    <!-- One block, so the modal's own gap between children doesn't add to the spacing here. -->
    <div>
      <section v-for="group in groups" :key="group.key" class="mb-5 last:mb-0">
        <h3 class="mb-1 text-[12px] leading-[16px] font-semibold uppercase tracking-wider text-text-neutral-low">{{ group.title }}</h3>
        <ul>
          <li v-for="item in group.items" :key="item.label"
              class="flex items-center justify-between gap-4 py-2 border-b border-stroke-separator last:border-b-0">
            <span class="text-[15px] leading-[20px] text-text-neutral-high">{{ item.label }}</span>
            <span class="flex shrink-0 items-center gap-1 text-[13px] text-text-neutral-medium">
              <template v-if="item.keys">
                <kbd v-for="keyCap in item.keys" :key="keyCap" class="shortcut-key">{{ keyCap }}</kbd>
                <span v-if="item.after" class="ml-1">{{ item.after }}</span>
              </template>
              <span v-else>{{ item.gesture }}</span>
            </span>
          </li>
        </ul>
      </section>
    </div>
  </sheet-modal>
</template>

<script setup>
import { computed, defineEmits, defineProps, toRef } from 'vue';
import SheetModal from '@/components/ui/SheetModal.vue';
import { translate } from '@/composables/useCaptionSettings';
import { useKeyboardShortcutGroups } from '@/composables/useKeyboardShortcuts';

const props = defineProps({
  modelValue: Boolean,
  // The room's view ('default' | 'chromakey'): its shortcuts are listed first.
  mode: {
    type: String,
    required: false,
    default: 'default',
  },
})

const emit = defineEmits(['update:modelValue'])

const title = computed(() => translate('shortcuts_title', 'Keyboard shortcuts'))
const groups = useKeyboardShortcutGroups(toRef(props, 'mode'))
</script>

<style scoped>
.shortcut-key {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 6px;
  background: var(--color-button-secondary-mono-resting);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.35);
  color: var(--color-text-neutral-high);
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
}
</style>
